"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sappada": {
    "cdc840b5": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "bach-poch": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "77ffa5f0": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "cima-sappada-zepodn": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "57c43f2b": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "cottern-cottern": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6287474c": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "cretta-crette": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6cc915f6": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "ecche-eke": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b7105154": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "fontana-prunn": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "39f9698f": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "granvilla-dorf": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a6307089": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "hoffe-houve": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea10900d": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "kratten-krotn": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f5d0e413": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "lerpa-lerpa": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c7d067dd": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "mulbach-mulpa": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4168abd5": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "palu-moss": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b6491978": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "pill-pill": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "436b2cc5": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "puicher-puiche": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "73279913": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "skipSearch": false
    }],
    "soravia-begar": [{
      "hkey": "ca48813b",
      "slug": "sappada",
      "name": "Sappada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;